import { SortBy, SortingDirection } from 'spw-components/collab/types';
import { EntityList } from 'spw-redux/types';
import { IProject } from '../projects/types';
import { Team } from '../teams/types';
import { IUser } from '../user/types';

export enum JoinRequestStatus {
  approved = 'APPROVED',
  pending = 'PENDING',
  rejected = 'DENIED',
}
export interface JoinRequest {
  id: number;
  insertedAt: string;
  projectId?: number;
  project: IProject;
  team?: Team;
  teamId?: number;
  user?: IUser;
  userId?: number;
  status: JoinRequestStatus;
}
export type CompletedJoinRequest = Pick<JoinRequest, 'id' | 'status'>;

export type JoinRequestSlimForList = Omit<JoinRequest, ''>;

export type JoinRequestListItemVM = Omit<JoinRequest, ''>;

export type JoinRequestsSortBy = SortBy<'user' | 'insertedAt' | 'team'>;

export type GetJoinRequestsParams = {
  sort?: JoinRequestsSortOptions;
  page?: number;
  perPage?: number;
};

export type NotificationRequestTotals = {
  projectRequestsTotal: number;
  teamRequestsTotal: number;
};

export interface IJoinRequestsState {
  teamJoinRequestsList: EntityList<JoinRequestListItemVM>;
  allTeamsJoinRequestsList: EntityList<JoinRequestListItemVM>;
  loadingUserPendingProjectRequests?: boolean;
  userPendingProjectRequestsMap?: Record<number, JoinRequest>;
  projectJoinRequestsList: EntityList<JoinRequestListItemVM>;
  userPendingTeamRequestsMap: Record<number, JoinRequestListItemVM>;
  joinRequestBeingResponded?: number | null;
  userProjectsJoinRequestsList: EntityList<JoinRequestListItemVM>;
  notificationRequestTotals: NotificationRequestTotals;
}

export type JoinRequestsSortOptions = {
  insertedAt?: SortingDirection;
  team?: SortingDirection;
  project?: SortingDirection;
  user?: SortingDirection;
  userOffice?: SortingDirection;
};
